import React from "react";
import { Footer as CefcomCondensedFooter } from "@ef-central-efcom/cefcom-footertw";
import { IFooterData, ILink, IBlock, ILogo } from "@ef-central-efcom/cefcom-footertw/build/types";

import { BlokBase } from "../../../Common/StoryblokTypes";

const footerData: IFooterData = {
  footer: {
    settings: {
      host: "",
      siteRootSlug: "",
      marketCode: "",
      marketNativeName: "",
      isRtl: true,
      isToggleMarket: false,
      languageCode: "",
      footerType: "condensed-footer",
      theme: "light",
      hideChangeCountryLink: true,
      hideLanguageToggle: true,
    },
    sections: [],
    legalLinks: [],
    copyrightLinks: [],
    serviceLabels: [],
    blocks: [],
    logo: {
      logoSrc: "",
      logoUrl: "/",
      logoFallback: "",
      altLogoSrc: "",
      logoAltText: "EF",
      altText: "EF",
      footerLogo: "",
      logos: ["https://media.ef.com/00.svg"],
    } as ILogo,
    additionalCopyrightText: "",
  },
  toggleLinks: null,
  changeCountryLinks: [],
};

export interface FooterBlok extends BlokBase {
  sections: Array<IBlock>;
  legalLinks: Array<ILink>;
  copyrightLinks: Array<ILink>;
}

interface FooterProps {
  blok: FooterBlok;
}

const Footer: React.FC<FooterProps> = ({ blok }) => {
  const data: IFooterData = {
    ...footerData,
    footer: {
      ...footerData.footer,
      sections: blok.sections,
      legalLinks: blok.legalLinks,
      copyrightLinks: blok.copyrightLinks,
    },
  };

  return (
    <>
      <CefcomCondensedFooter data={data} />
    </>
  );
};

export default Footer;
